import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 个人中心
   * 发送邮件验证码
   */
  sendEmail_Users(params, noAuth) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(noAuth ? URL.SEND_EMAIL_CODE_NO_AUTH : URL.SEND_EMAIL_CODE, {
          params,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 个人中心
   * 发送短信验证码
   */
  sendSms_Users(params, noAuth) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(noAuth ? URL.SEND_PHONE_CODE_NO_AUTH : URL.SEND_PHONE_CODE, {
          params,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 个人中心
   * 发送语音验证码
   */
  sendVoice_Users(params, noAuth) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(noAuth ? URL.SEND_VOICE_CODE_NO_AUTH : URL.SEND_PHONE_VOICE_CODE, {
          params,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 资金管理
   * 发送邮件验证码
   */
  sendEmail_Wallet(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.POST_EMAIL_CODE, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 资金管理
   * 发送短信验证码
   */
  sendSms_Wallet(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.SEND_PHONE_MSG, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 资金管理
   * 发送短信验证码
   */
  sendSms_Asset(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.USER_WITHDRAW_SENDMSG, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
};
